import { getURLSearchParams, getCookieByName } from "@/utils";
import type { LoginResponse } from "@/components/GlobleModal/LoginModal/service";
import { _postRequest } from "./request-util";

// 根据邀请码查询用户信息
export async function getInviteCodeUserInfo(inviteCode?: string): Promise<LoginResponse | undefined> {
  inviteCode = inviteCode ?? getURLSearchParams("inviteCode") ?? getCookieByName("inviteCode") ?? "";

  if (inviteCode) {
    // 链接带有邀请码
    const data = await _postRequest("/user/queryByInviteCode", {
      data: { inviteCode },
      headers: { "content-type": "application/json" }
    });

    if (data?.id) {
      return data as LoginResponse;
    }
  }

  const source = getURLSearchParams("source");

  if (source === "personal_model_share") {
    // 链接带有模型代码
    const pathnameCols = location.pathname.split("/");

    if (pathnameCols.length > 2) {
      const modelCode = pathnameCols[2];

      const data = await _postRequest("/external/getModelByCode", {
        data: { code: modelCode }
      });

      if (data && data.userId) {
        const userInfo = await _postRequest("/external/userInfo", {
          data: { userId: data.userId }
        });

        if (userInfo?.id) {
          return userInfo as LoginResponse;
        }
      }
    }
  }
}
